/** localStorage 키 (모두 "kr-stock:" prefix) */
export const STORAGE_PREFIX = "kr-stock";

export const STORAGE_KEYS = {
  theme: `${STORAGE_PREFIX}:theme`,
  history: `${STORAGE_PREFIX}:history`,
  watchlist: `${STORAGE_PREFIX}:watchlist`,
  lang: `${STORAGE_PREFIX}:lang`,
  onboarded: `${STORAGE_PREFIX}:onboarded`,
} as const;

/** 워치리스트 점수 변동 toast 알림 임계값 (±N점 이상이면 알림) */
export const SCORE_DELTA_ALERT_THRESHOLD = 5;
